
import OrderToSyncOrderRequest from '../../../consume/application/useCases/consume/OrderToSyncOrderRequest';
import { IOrder } from '../../../cart/domain/models/IOrder';
import { ICustomerFormValue } from '../../../../pages/TableMap/components/customerForm/ICustomerFormValue';
import { SyncOrderRequest, SyncOrderTransactions } from '../../domain/dtos/SyncPrePaidTickets';
import { IPrePaidTicketsService } from '../../domain/interfaces/IPrePaidTicketsService';
import { OrderStatus } from '../../domain/OrderStatus';
import { PaymentType } from '../../../consume/domain/models/PaymentType';
import { IOperator } from '../../../operator/domains/models/Operator';
import { IDiscountValue } from '../../../../pages/catalog/components/discount/Discount';

const SendTicketConsumeOrderUseCase = async (
  ConsputionApi: IPrePaidTicketsService,
  values: {
    localId: string,
    order: IOrder,
    totalAmount: number,
    operator: IOperator,
    registerSessionId: string,
    customer?: ICustomerFormValue,
    transactions: SyncOrderTransactions[]
    codePanel?: string;
    discount?: IDiscountValue;
    notes?: string
  }
) => {
  const request: SyncOrderRequest = OrderToSyncOrderRequest(
    {
      registerSessionId: values.registerSessionId,
      localId: values.localId,
      order: values.order,
      totalAmount: values.totalAmount - (values.discount?.amount || 0),
      operatorId: values.operator.id,
      orderStatus: OrderStatus.PAGAMENTO_REALIZADO,
      customer: values.customer,
      transactions: values.transactions,
      codePanel: values.codePanel,
      discount: values.discount?.amount,
      notes: values.notes
    }
  );

  await ConsputionApi.syncOrder([request]);
  return values;
};
export default SendTicketConsumeOrderUseCase;
